import { fetchPaymentMethods } from './effects';
import { $paymentMethods } from './states';

// Fetch payment methods
$paymentMethods.on(fetchPaymentMethods.doneData, (_, data) => data);
